"use client";
import * as React from "react";
const SvgUnfoldMoreOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5 2.83 8.17 6l1.41-1.41L5 0 .41 4.59 1.83 6zm0 10.34L1.83 10 .42 11.41 5 16l4.59-4.59L8.17 10z" }));
export {
  SvgUnfoldMoreOutlined as default
};
